import { createAsyncThunk } from "@reduxjs/toolkit";
import { KubernetesResourceType } from "@/store/ai-kubernetes-recommendations/utils/types/types";
import {
  cloudChiprApi,
  GetUsersMeOrganisationsCurrentKubernetesClustersByClusterIdAndKubernetesResourceTypeApiArg,
} from "@/services/cloudchipr.api";
import { AllTypeResourceItem } from "@/store/resources-grid/utils/types/resources";

interface GetKubernetesResourceByResourceTypeArgs {
  name: string;
  clusterId: string;
  namespace?: string;
  resourceType: KubernetesResourceType;
}

export const getKubernetesResourceByResourceTypeThunk = createAsyncThunk(
  "aiKubernetesRecommendations/getKubernetesResourceByResourceType",
  async (
    {
      name,
      clusterId,
      namespace,
      resourceType,
    }: GetKubernetesResourceByResourceTypeArgs,
    { dispatch },
  ): Promise<AllTypeResourceItem | undefined> => {
    const {
      getUsersMeOrganisationsCurrentKubernetesClustersByClusterIdAndKubernetesResourceType,
    } = cloudChiprApi.endpoints;

    try {
      return await dispatch(
        getUsersMeOrganisationsCurrentKubernetesClustersByClusterIdAndKubernetesResourceType.initiate(
          {
            name,
            clusterId,
            namespace: namespace ?? "",
            kubernetesResourceType:
              fromResourceTypeToKubernetesResourceType(resourceType),
          },
        ),
      ).unwrap();
    } catch (e) {
      console.error(e);
    }
  },
);

const fromResourceTypeToKubernetesResourceType = (
  resourceType: KubernetesResourceType,
): GetUsersMeOrganisationsCurrentKubernetesClustersByClusterIdAndKubernetesResourceTypeApiArg["kubernetesResourceType"] => {
  return `${resourceType.replace(
    "kubernetes_",
    "",
  )}s` as GetUsersMeOrganisationsCurrentKubernetesClustersByClusterIdAndKubernetesResourceTypeApiArg["kubernetesResourceType"];
};
